var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsersIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#users-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.19 7.18A2.493 2.493 0 0 0 6.7 9.67v4.98a.83.83 0 1 1-1.66 0V9.64a2.828 2.828 0 0 1-.69.017.741.741 0 0 1-.14.013h-.36a1.3 1.3 0 0 0-1.3 1.304v2.016a.83.83 0 1 1-1.66 0v-2.016c0-1.055.55-1.981 1.38-2.507a2.906 2.906 0 0 1 3.61-4.322c-.01-.094-.01-.189-.01-.286 0-1.833 1.49-3.32 3.32-3.32 1.83 0 3.32 1.487 3.32 3.32 0 .097 0 .192-.01.286a2.905 2.905 0 0 1 3.61 4.322 2.963 2.963 0 0 1 1.38 2.507v2.016a.83.83 0 1 1-1.66 0v-2.016a1.3 1.3 0 0 0-1.3-1.304h-.36c-.05 0-.1-.005-.14-.013a2.864 2.864 0 0 1-.69-.017v5.01a.83.83 0 1 1-1.66 0V9.67c0-1.376-1.11-2.49-2.49-2.49Zm0-1.661c-.92 0-1.66-.743-1.66-1.66 0-.916.74-1.66 1.66-1.66.92 0 1.66.744 1.66 1.66 0 .917-.74 1.66-1.66 1.66Zm-4.56 0c-.69 0-1.25.558-1.25 1.246a1.246 1.246 0 1 0 1.25-1.246Zm9.13 0c-.69 0-1.25.558-1.25 1.246a1.246 1.246 0 1 0 1.25-1.246Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "users-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h17v16H0z"
})))));
export { SvgUsersIcon as ReactComponent };
export default __webpack_public_path__ + "images/users-icon.svg";